import { render, staticRenderFns } from "./RegistroArce.vue?vue&type=template&id=591deaa8"
import script from "./RegistroArce.vue?vue&type=script&lang=js"
export * from "./RegistroArce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports